module.exports = __webpack_public_path__ + "img/avatar_6.102c9096.jpg";